export default "__VITE_ASSET__Bpjc2dtv__"